module.exports = __webpack_public_path__ + "img/pensive.c86950d4.png";